import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=c3902f02&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"
import style0 from "./Panel.vue?vue&type=style&index=0&id=c3902f02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3902f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3902f02')) {
      api.createRecord('c3902f02', component.options)
    } else {
      api.reload('c3902f02', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=c3902f02&scoped=true", function () {
      api.rerender('c3902f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/social_school/Panel.vue"
export default component.exports